document.addEventListener("DOMContentLoaded", function () {
    let x = window.innerWidth <= 600 ? 6 : 5; // Initial count of items to show
    const categories = document.querySelectorAll(".category");
    const loadMoreButton = document.querySelector(".load_more");
    const blocksSize = parseInt(document.querySelector('.lets_get_box.blocks').getAttribute('data-blocks-size'));
    // Function to show categories with a smooth transition

    if (categories.length === 0) {
      return;
    }

    const showCategories = (count) => {
      categories.forEach((category, index) => {
        if (index < count) {
          category.style.display = "block"; // Make sure the element is rendered
          setTimeout(() => {
            category.classList.add("show"); // Trigger the transition effect
          }, 50);
        }
      });
    };
  
    // Show initial 5 categories
    showCategories(x);
  
    // Add click event listener to "Load more" button
    loadMoreButton?.addEventListener("click", (e) => {
      e.preventDefault();
      x += blocksSize; // Increment the count of elements to show
      showCategories(x);
  
      // Hide the "Load more" button if all elements are visible
      if (x >= categories.length) {
        loadMoreButton.style.display = "none";
      }
    });

    $(document).ready(function() {
        $('.slider-for').slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: true,
          responsive: [
            {
              breakpoint: 1180,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1,
                arrows: false,
                dots: true,
                slidesToScroll: 1
              }
            }
          ]
        });
      });
});